"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M18.44 23.96H16.1l-.08 13.12a23.475 23.475 0 0 0 2.36.82zm3.68-.82v15.9c.3.02 1-.26 1.3-.26.36 0 .7-.02 1.06-.04v-15.6zM34 33.76a17.259 17.259 0 0 0 2.36-2.32v-10.6H34zm-21.82-9L17 19.2l4.16 2.26s4.34-2.5 4.4-2.6c.04-.12 5.56-4.5 5.56-4.5l4.72 3.94 2.42-1.74-.42-1.6-1.84.5-4.86-4.1-9.98 7.36-4.12-2.44-5.5 6.4-3.44.24v2.22zm.18 2.38H10v3.18a17.124 17.124 0 0 0 2.34 2.16zm18.08-8H28.1l-.1 18.8a19.556 19.556 0 0 0 2.36-.86z" }),
  React.createElement("path", { d: "M24 1A23.013 23.013 0 0 0 1.1 24.14a22.9 22.9 0 1 0 45.8 0A23.012 23.012 0 0 0 24 1zm0 43.72a20.581 20.581 0 0 1 0-41.16 20.581 20.581 0 0 1 0 41.16z" })
);

